import { API } from "aws-amplify";
import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { IIndividualData } from "../../../../models/RegistryIndividual";
import { APIEndpoints, QueryKeys } from "../../config";

const makeApiRequest = (
  registryId: string,
  individualId: string
): Promise<IIndividualData> => {
  const qParams = {};

  return API.get(
    APIEndpoints.private,
    `/api/v1/registries/${registryId}/individual/${individualId}`,
    qParams
  );
};

interface IProps {
  registryId: string;
  individualId: string;
}

export const useReadRegistryIndividual = ({
  registryId,
  individualId,
}: IProps) => {
  return useQuery<IIndividualData, AxiosError>(
    QueryKeys.registryIndividualData(registryId, individualId),
    () => makeApiRequest(registryId, individualId),
    {
      retry: 1,
    }
  );
};
